import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { RingBuffer } from './ring_buffer';
export var GrowingRingBuffer = /*#__PURE__*/function (_RingBuffer) {
  _inherits(GrowingRingBuffer, _RingBuffer);
  /**
   * Constructs a `GrowingRingBuffer`.
   */
  function GrowingRingBuffer() {
    _classCallCheck(this, GrowingRingBuffer);
    return _possibleConstructorReturn(this, _getPrototypeOf(GrowingRingBuffer).call(this, GrowingRingBuffer.INITIAL_CAPACITY));
  }
  _createClass(GrowingRingBuffer, [{
    key: "isFull",
    value: function isFull() {
      return false;
    }
  }, {
    key: "push",
    value: function push(value) {
      if (_get(_getPrototypeOf(GrowingRingBuffer.prototype), "isFull", this).call(this)) {
        this.expand();
      }
      _get(_getPrototypeOf(GrowingRingBuffer.prototype), "push", this).call(this, value);
    }
  }, {
    key: "unshift",
    value: function unshift(value) {
      if (_get(_getPrototypeOf(GrowingRingBuffer.prototype), "isFull", this).call(this)) {
        this.expand();
      }
      _get(_getPrototypeOf(GrowingRingBuffer.prototype), "unshift", this).call(this, value);
    }
    /**
     * Doubles the capacity of the buffer.
     */
  }, {
    key: "expand",
    value: function expand() {
      var newCapacity = this.capacity * 2;
      var newData = new Array(newCapacity);
      var len = this.length();
      // Rotate the buffer to start at index 0 again, since we can't just
      // allocate more space at the end.
      for (var i = 0; i < len; i++) {
        newData[i] = this.get(this.wrap(this.begin + i));
      }
      this.data = newData;
      this.capacity = newCapacity;
      this.doubledCapacity = 2 * this.capacity;
      this.begin = 0;
      this.end = len;
    }
  }]);
  return GrowingRingBuffer;
}(RingBuffer);
GrowingRingBuffer.INITIAL_CAPACITY = 32;